define("ROOM4.CCAProductGallery.CCAProductGallery.Maintenance.View", [
  "PageType.Base.View",
  "Configuration",
  "Utils",
  "room4_ccaproductgallery_maintenance.tpl",
], function (
  PageTypeBaseView,
  Configuration,
  Utils,
  room4_ccaproductgallery_maintenance_tpl
) {
  "use strict";

  return PageTypeBaseView.PageTypeBaseView.extend({
    template: room4_ccaproductgallery_maintenance_tpl,

    attributes: {
      id: "CCAProductGalleryMaintenance",
      class: "CCAProductGalleryMaintenance",
    },

    initialize: function initialize() {
      this.title =
        Configuration.get("CCAProductGallery.maintenance.title") ||
        Utils.translate("Gallery Maintenance");
      this.page_header = this.title;
      this.message =
        Configuration.get("CCAProductGallery.maintenance.message") ||
        Utils.translate(
          "Our gallery is temporarily unavailable while we update it. Please check back soon."
        );
    },

    getContext: function getContext() {
      return {
        title: this.title,
        message: this.message,
      };
    },
  });
});
